<template>
<div class="w100">
    <b-row>
        <b-col cols="3" class="text-left">
            <p class="mr-10 lh-30 mb-0">Intensity:</p>
         </b-col>
        <b-col cols="9" class="text-left">
            <number-input v-model.number="ioInfo.modules.io.level" :min="0" :max="999" inline center controls size="small"></number-input>
        </b-col>
    </b-row>
    <b-row class="mtop10">
         <b-col cols="3" class="text-left">
            <p class="mr-10 lh-30 mb-0">Activation:</p>
         </b-col>
          <b-col cols="9" class="text-left">
            <el-select v-model="ioInfo.modules.io.activation" placeholder="Select.." >
                <el-option v-for="item in freqs" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
          </b-col>
    </b-row>
    <actions :has-changes="hasChanges" v-on:onSave="onSave" v-on:onCancel="onCancel"></actions>
</div>

</template>

<script>
import Actions from "./utils/Actions";

export default {
    name: 'Ionization',
    components:{
        Actions
    },
    props: {
        poolId: Object
    },
    mounted() {
        let fresh = JSON.parse(JSON.stringify(this.poolId));
        this.ioInfo = fresh
        this.original = JSON.parse(JSON.stringify(fresh));
    },
    data() {
        return {
            hasChanges: false,
            original: null, 
            ioInfo: {
                'modules':{
                    'io':{
                        'activation': 0,
                        'level': 0
                    }
                }
            },
            freqs: [{
                    value: 0,
                    label: this.$t("messages.always")
                },
                {
                    value: 10,
                    label: '10 '+this.$t("messages.minutes")
                },
                {
                    value: 20,
                    label: '20 '+this.$t("messages.minutes")
                },
                {
                    value: 30,
                    label: '30 '+this.$t("messages.minutes")
                }
            ]
        }
    },

    watch: {
        'ioInfo': {
            handler(value) {
                this.hasChanges = (JSON.stringify(value) === JSON.stringify(this.original)) ? false : true
            },
            deep: true
        }
    },

    methods:{
        onSave () {
            this.$emit('onSave',this.original, this.ioInfo, 'io');
            this.original = JSON.parse(JSON.stringify(this.ioInfo));
            this.hasChanges = false
        },
        onCancel() {
            this.ioInfo = JSON.parse(JSON.stringify(this.original));
            this.hasChanges = false;
        },
        setValue: function(value) {
            console.log(value);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Ionization.vue